export enum RolesEnum {
  Admin = 1,
  Regular,
  Lead,
}
